import { z } from 'zod';
import { PermissionsChangedSchema } from '@/domain/ws/global/events/permissionsChanged';

export const GlobalEventSchema = z.discriminatedUnion('event', [PermissionsChangedSchema]);

export type GlobalEvent = z.infer<typeof GlobalEventSchema>;
